//TODO: remove and replace with sg-ui-components version

import { getCMSObject } from 'sg-ui-components';

const UNEXPECTED_ERROR =
    'Unexpected Server Error. Please try again. If you still see the error, then please submit <a href="/feedback#contact">Feedback</a> form for further assistance.';

const interpolateDataIntoTemplate = (template, values) => {
    return template.replace(/<(\w+)>/g, (_, key) => values?.[key] || `<${key}>`);
};

export const errorMessage = (code, data) => {
    const cmsErrorMessages = getCMSObject('data.messages.errorMessages.jsonBlock');
    let result = cmsErrorMessages[code] || UNEXPECTED_ERROR;
    if (data) {
        result = interpolateDataIntoTemplate(result, data);
    }
    return result;
};
